import { useCallback, useEffect, useState, useMemo } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { routes } from './routes';

export function useOfficeApi({ patient, patients, fetchPatients, getPatientInfo, logout }) {
  const history = useHistory();
  const { params } = useRouteMatch();
  const [currentPatient, setCurrentPatient] = useState();
  const [personalCodeModalIsVisible, setPersonalCodeModalIsVisible] = useState(false);
  const token = localStorage.getItem('token');
  const storagePatientId = localStorage.getItem('patientId');
  const declarationSigned = localStorage.getItem('declarationSigned') === 'true';

  const currentPage = useMemo(() => {
    const currentRoute = `/${params.pageName}${params.pageId ? `/${params.pageId}` : ''}`;

    return routes.find((route) => route.regExp.test(currentRoute));
  }, [params]);

  const setPatient = useCallback(
    (patientId) => {
      const patient = patients.data.find((patient) => +patient.id === +patientId);

      if (patient) {
        localStorage.setItem('patientId', patient.id);
        setCurrentPatient(patient);
      }
    },
    [patients],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (token && !patients.loading && !patients.loaded) fetchPatients();
  }, [token, declarationSigned, fetchPatients, patients.loaded, patients.loading]);

  useEffect(() => {
    if (storagePatientId && !currentPatient && patients.data.length) {
      const patient = patients.data.find((patient) => +patient.id === +storagePatientId);
      if(!patient) {
        localStorage.removeItem('patientId');
        setCurrentPatient(null);
        return;
      }
      setCurrentPatient(patient);
    }
  }, [currentPatient, patients.data, storagePatientId]);

  useEffect(() => {
    if (!storagePatientId && !currentPatient && patients.data.length === 1) {
      localStorage.setItem('patientId', patients.data[0].id);
      setCurrentPatient(patients.data[0]);
    }
  }, [patients, currentPatient, storagePatientId]);

  useEffect(() => {
    if (!patient.loading && currentPatient && currentPatient.id !== patient?.data?.id) {
      const savedPatientId = localStorage.getItem('patientId');
      if(savedPatientId) {
        getPatientInfo(currentPatient.id);
      }
    }
  }, [currentPatient, getPatientInfo, patient]);

  useEffect(() => {
    if (!token) {
      history.push('/');
      logout();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    currentPatient,
    setPatient,
    personalCodeModalIsVisible,
    setPersonalCodeModalIsVisible,
    storagePatientId,
    currentPage,
  };
}
